import { render, staticRenderFns } from "./ImapAccount.vue?vue&type=template&id=4b0a1906&"
import script from "./ImapAccount.vue?vue&type=script&lang=js&"
export * from "./ImapAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports